<template>
  <SummaryPanel title="Weather & Wave" :badges="badges" :anchor-id="anchorId">
    <div class="weather-stats">
      <span>Wave <b>{{ formatValue(model.waveHeight, 'm') }}</b></span>
      <span>Sea State <b :class="getSeaStateTextClass(model.seaState)">{{ model.seaState || 'N/A' }}</b></span>
      <span>Period <b>{{ formatValue(model.wavePeriod, 's') }}</b></span>
    </div>

    <div v-if="model.directions.length" class="panel-mini-row weather-body">
      <DonutChart
        v-if="donutItems.length"
        :data="donutItems"
        label-key="label"
        value-key="raw"
        :colors="donutColors"
        :width="96"
        :height="96"
        :show-legend="false"
      />
      <div class="panel-table-scroll weather-table">
        <table class="table panel-table">
          <thead class="thead-light">
            <tr>
              <th>Direction</th>
              <th>Share</th>
              <th>Duration</th>
              <th>Speed</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="direction in model.directions" :key="direction.key">
              <td>
                <span class="weather-swatch" :style="{ background: directionColor(direction.key) }"></span>
                {{ direction.label }}
              </td>
              <td>{{ formatNum(direction.share, 1) }}%</td>
              <td>{{ toDuration(direction.seconds) }}</td>
              <td>{{ formatSpeed(direction.averageSpeedKmh) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </SummaryPanel>
</template>

<script>
import { formatNum } from '@/util/number';
import { toDuration } from '@/util/date';
import { kmhToKnot } from '@/util/units';
import { useVoyageFormatters } from '@/views/voyage/composables/useVoyageFormatters';
import SummaryPanel from './SummaryPanel.vue';
import DonutChart from '../charts/DonutChart.vue';

export default {
  name: 'WeatherWavePanel',
  components: {
    SummaryPanel,
    DonutChart,
  },
  props: {
    model: {
      type: Object,
      required: true,
    },
    badges: {
      type: Array,
      default: () => [],
    },
    anchorId: {
      type: String,
      default: null,
    },
  },
  setup() {
    const { getSeaStateTextClass } = useVoyageFormatters();
    return { getSeaStateTextClass };
  },
  data() {
    return {
      colors: ['#0d6efd', '#fd7e14', '#20c997', '#6f42c1', '#dc3545', '#795548'],
    };
  },
  computed: {
    donutItems() {
      return this.model.directions
        .filter((d) => d.seconds > 0)
        .map((d, index) => ({
          key: d.key, label: d.label, raw: d.seconds, color: this.colors[index % this.colors.length],
        }));
    },
    donutColors() {
      return this.donutItems.map((item) => item.color);
    },
  },
  methods: {
    // arah 0 detik gak ada di donut, swatch transparan
    directionColor(key) {
      const item = this.donutItems.find((d) => d.key === key);
      return item ? item.color : 'transparent';
    },
    formatNum,
    toDuration,
    formatValue(value, unit) {
      return value === null ? 'N/A' : `${formatNum(value, 2)} ${unit}`;
    },
    formatSpeed(kmh) {
      return kmh === null ? 'N/A' : `${formatNum(kmhToKnot(kmh), 2)} kn`;
    },
  },
};
</script>

<style src="./summaryPanel.css"></style>

<style scoped>
.weather-stats {
  display: flex;
  flex-wrap: wrap;
  gap: 4px 16px;
  font-size: 14px;
  margin-bottom: 8px;
}

.weather-stats b {
  font-weight: 600;
}

.weather-body {
  flex-wrap: nowrap;
  align-items: flex-start;
}

.weather-table {
  flex: 1;
  min-width: 0;
}

.weather-swatch {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 2px;
  margin-right: 4px;
}

@media (max-width: 575.98px) {
  .weather-body {
    flex-wrap: wrap;
    justify-content: center;
  }
}
</style>
